import React from "react";
import "./button.scss";

const Button = ({ btnText, btnStyle, onClick }) => {
  return (
    <>
      <button type="submit" className={btnStyle} onClick={onClick}>
        {btnText}
      </button>
    </>
  );
};

export default Button;
